/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent, isPepRouteEnabled = false) => {

  const pepRoutes = isPepRouteEnabled ? {
    pep: {
      name: 'pep',
      componentName: 'PepDesktopContainer',
      chunk: () => import(
      /* webpackChunkName: "pep" */
        './pages/pep/PepDesktopContainer'
      ),
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepDesktopContainer.js'))
            .PepDesktopContainer
          : currentRouteName === 'pep'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepDesktopContainer }))
            );
      },
      path: '/:context?/pep/:slug?/:itemId/*',
      prefetch: ['product', 'compare'],
      channel: 'desktop'
    },

    // @TODO: Named export doesn't match the component file name.
    pepMobile: {
      name: 'pep-mobile',
      componentName: 'PepMobileContainer',
      chunk: () => import(
      /* webpackChunkName: "pep-mobile" */
        './pages/pep/PepMobileContainer'
      ),
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepMobileContainer.js'))
            .PepMobileContainer
          : currentRouteName === 'pep-mobile'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobileContainer }))
            );
      },
      path: '/:context?/pep/:slug?/:itemId/*',
      prefetch: ['productMobile'],
      channel: 'mobile'
    },
  } : {}

  return {
    browse: {
      name: 'browse-and-search',
      componentName: 'BrowseAndSearchContainer',
      chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
        './pages/browse-search/BrowseAndSearchContainer'
      ),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
          : currentRouteName === 'browse-and-search'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
      },
      path: '/:context?/b/*',
      prefetch: ['product'],
      channel: 'desktop'
    },

    browseMobile: {
      name: 'browse-and-search-mobile',
      componentName: 'BrowseAndSearchMobileContainer',
      chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
        './pages/browse-search/BrowseAndSearchMobileContainer'
      ),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')).BrowseAndSearchMobileContainer
          : currentRouteName === 'browse-and-search-mobile'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })))
      },
      path: '/:context?/b/*',
      prefetch: ['productMobile'],
      channel: 'mobile'
    },

    search: {
      name: 'browse-and-search',
      componentName: 'BrowseAndSearchContainer',
      chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
        './pages/browse-search/BrowseAndSearchContainer'
      ),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
          : currentRouteName === 'browse-and-search'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
      },
      path: '/:context?/s/*',
      prefetch: ['product'],
      channel: 'desktop'
    },

    searchMobile: {
      name: 'browse-and-search-mobile',
      componentName: 'BrowseAndSearchMobileContainer',
      chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
        './pages/browse-search/BrowseAndSearchMobileContainer'
      ),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')).BrowseAndSearchMobileContainer
          : currentRouteName === 'browse-and-search-mobile'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })))
      },
      path: '/:context?/s/*',
      prefetch: ['productMobile'],
      channel: 'mobile'
    },

    product: {
      name: 'product',
      componentName: 'ProductContainer',
      chunk: () => import(
      /* webpackChunkName: "product" */
        './pages/product/ProductContainer'
      ),
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductContainer.js')).ProductContainer
          : currentRouteName === 'product'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })))
      },
      path: '/:context?/p/:slug?/:itemId/*',
      prefetch: ['browse'],
      channel: 'desktop'
    },

    productMobile: {
      name: 'product-mobile',
      componentName: 'ProductMobileContainer',
      chunk: () => import(
      /* webpackChunkName: "product-mobile" */
        './pages/product/ProductMobileContainer'
      ),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductMobileContainer.js')).ProductMobileContainer
          : currentRouteName === 'product-mobile'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductMobileContainer })))
      },
      path: '/:context?/p/:slug?/:itemId/*',
      prefetch: ['browseMobile'],
      channel: 'mobile'
    },

    compare: {
      name: 'compare',
      componentName: 'CompareContainer',
      chunk: () => import(
      /* webpackChunkName: "compare" */
        './pages/compare/CompareContainer'
      ),
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/compare/CompareContainer.js')).CompareContainer
          : currentRouteName === 'compare'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer })))
      },
      path: '/:context?/compare/*',
      channel: null
    },

    home: {
      name: 'home',
      componentName: 'Home',
      chunk: () => import(
      /* webpackChunkName: "home" */
        './pages/Home'
      ),
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
          : currentRouteName === 'home'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
      },
      path: '/:context?/*',
      channel: null
    },
    ...pepRoutes
  }
};
